import { singleItemWrapper } from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { ImageUrl } from '../../types/shared'
import type { Profile, UpdateProfileBody } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const {
      get: getProfile,
      update: updateProfile,
      remove: removeProfile
    } = singleItemWrapper<Profile, UpdateProfileBody>(apiClient, {
      path: `/api/v${version}/profile`
    })

    return {
      getProfile,
      updateProfile,
      removeProfile,

      uploadAvatar: (formData: FormData) =>
        apiClient.post<ImageUrl>(`/api/v${version}/profile/upload-avatar`, {
          body: formData
        }),

      removeAvatar: () =>
        apiClient.delete(`/api/v${version}/profile/delete-avatar`),

      removeStyles: (property: string) =>
        apiClient.delete(`/api/v${version}/profile/styles/${property}`)
    }
  }
} satisfies Starter
